import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const HeightDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <g fill="none" fillRule="evenodd" transform="translate(-1 1)">
      <rect
        width="23.936"
        height="8.976"
        x=".997"
        y="6.316"
        fill="#D7E0EE"
        rx="1.995"
        transform="rotate(-36 12.965 10.805)"
      />
      <g
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.995"
      >
        <path
          d="M5.135 4.031L6.858 6.448M9.973 0L11.123 1.539M0 6.981L1.15 8.52"
          transform="translate(4.987 3.324)"
        />
      </g>
    </g>
  </SvgWrapper>
)
